
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"c-livevideo-list\">\n  ")
    ;  if (data.length > 1) { 
    ; __append("\n    ")
    ;  for (var i = 0, iLen = data.length; i < iLen; i++) { 
    ; __append("\n      <div class=\"c-livevideo-list__item ")
    ; if (data[i].isSelected == true) { 
    ; __append("c-livevideo-list__item--selected")
    ;  } 
    ; __append("\" data-index=\"")
    ; __append(escape(i))
    ; __append("\">\n        <span>线路")
    ; __append(escape(i + 1))
    ; __append("</span>\n        <section style=\"background-image: url(")
    ; __append(escape(data[i].poster))
    ; __append(")\"></section>\n        <div>")
    ; __append(escape(data[i].title))
    ; __append("</div>\n      </div>\n    ")
    ;  } 
    ; __append("\n  ")
    ;  } 
    ; __append("\n</div>")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/modules/f.compenont.video.mobile/app/modules/list/main.ejs
// module id = 482
// module chunks = 0